const baseUrl = 'https://api.vivyadocs.com/vivyadocs_app/';
// const baseUrl = 'http://127.0.0.1:8000/Vivyahire_app/';
export { baseUrl }